import axios from 'axios';
import { URL } from './api';

// Asks the backend to mint a one-time authenticated magic link (Universal Link).
// The web JWT never travels in the URL: the backend returns a short-lived link
// that opens the mobile app and logs the user in automatically. Backend:
// MobileMagicLinkView (bo/apps/users/views_magic.py). Response shape:
// { url: '<https universal link with one-time token>', expires_at: '<iso>' }.
export const getMagicLink = token =>
  axios.post(
    `${URL}/api/mobile-magic-link`,
    {},
    {
      headers: {
        Authorization: 'JWT ' + token,
      },
    }
  );

// Redeems a one-time magic token (from /magic?token=…) for the same
// {access, refresh} JWT pair as the password login. Used by the desktop
// fallback of MagicLanding to log the user into the web app directly.
export const verifyMagicToken = (token, client = 'web') =>
  axios.post(`${URL}/api/magic/verify`, { token, client });
